module.exports = __webpack_public_path__ + "img/fz-7.e21da87b.png";